import { defineMessage } from 'react-intl';

export const bookingI18n = {
  fromPricePerPerson: defineMessage({
    id: 'booking.from-price-per-person',
    defaultMessage: 'From {price} <small>per person</small>'
  }),
  fromPricePerPersonShort: defineMessage({
    id: 'booking.from-price-per-person.short',
    defaultMessage: 'From {price} <small>/ person</small>'
  })
};
